module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-PINTEREST.943e1f68.png";